export class Product {
  id: string;
  name: string;
  brand: string;
  type: string;
  number: string;
  status: string;
}



// WEBPACK FOOTER //
// /app/src/app/_models/product.ts